import { useCallback } from 'react'
import type { TGetTeamsCursorQueryParams, TGetTeamsQueryParams, TTeamsCursorPage } from '../api/types/teams'
import { CURSOR_LIST_PAGE_SIZE } from '../consts/api'
import { useWindowedCursorList } from './useWindowedCursorList'

type LoadTeamsPage = (
  arg: TGetTeamsCursorQueryParams,
  preferCacheValue?: boolean,
) => { unwrap: () => Promise<TTeamsCursorPage> }

export function useTeamsWindowedPage(
  resetKey: string | number,
  loadPage: LoadTeamsPage,
  queryArgs: TGetTeamsQueryParams,
) {
  const fetchPage = useCallback(
    async (cursor: string | null) => {
      const data = await loadPage({ ...queryArgs, cursor, limit: CURSOR_LIST_PAGE_SIZE }, true).unwrap()
      return {
        items: data.items ?? [],
        nextCursor: data.meta?.next_cursor ?? null,
      }
    },
    [loadPage, queryArgs],
  )

  return useWindowedCursorList({
    resetKey,
    fetchPage,
  })
}
